import React, { FC, useState, useCallback } from "react";
import LocationInput from "../LocationInput";
import GuestsInput from "../GuestsInput";
import StayDatesRangeInput from "./StayDatesRangeInput";
import { useClient } from "ClientContext";
import { useGetListings } from "hooks/useGetListings";

interface StaySearchFormProps {
  onSearch?: Function;
}

const StaySearchForm: FC<StaySearchFormProps> = ({ onSearch }) => {


  const [formData, setFormData] = useState({
    location: { city: "", state: "", country: "" },
    dates: { startDate: null, endDate: null },
    guests: 0,
  });
  const { isLocationFilter } = useClient();
const { handleSearch } = useGetListings();
  const handleInputChange = useCallback((field: string, value: any) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  }, []);

  const handleSearchClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
     // onSearch && onSearch(formData);
     handleSearch && handleSearch()
      window.parent.postMessage(formData, "*");
    },
    [formData, onSearch]
  );
  return (
    <form className="w-full relative mt-8 flex rounded-full shadow-xl dark:shadow-2xl bg-white dark:bg-neutral-800">
      {isLocationFilter && (
        <LocationInput
          className="flex-[1.5]"
          onChange={(value) => handleInputChange("location", value)}
        />
      )}
      <div className=" border-r border-slate-200 dark:border-slate-700 h-8"></div>
      <StayDatesRangeInput
        className="flex-[1.5]"
        onChange={(dates) => handleInputChange("dates", dates)}
      />
      <div className="self-center border-r border-slate-200 dark:border-slate-700 h-8"></div>
      <GuestsInput
        className="flex-1"
        onChange={(value) => handleInputChange("guests", value)}
        onSearch={handleSearchClick}
      />
    </form>
  );
};

export default React.memo(StaySearchForm);
